import { RestClient, RequestResponse } from "@infrastructure/clients/http/clients/base/rest.client";
import { CommonDto } from "@infrastructure/clients/http/common.dto";
import { BASE_URL } from "@infrastructure/clients/http/config";
import {
  ValidateResponseSchema,
  RegisterResponseSchema,
  TokenSchema
} from "@infrastructure/clients/http/clients/auth.schemas";
import * as z from "zod";
import { authEndpoints } from "@shared/integrations/messenger";

class AuthClientClass extends RestClient {
  baseUrl = BASE_URL;

  async validate(initDataRaw: string): Promise<RequestResponse<z.infer<typeof ValidateResponseSchema>>> {
    try {
      console.log(`[AuthClient.validate] Starting validate request to /api/auth/telegram/validate`);
      // Создаем AbortController для возможности отмены запроса
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
      }, 10000);
      
      try {
        const { validate, header } = authEndpoints();
        const result = await this.request("POST", validate, {
          headers: {
            [header]: initDataRaw,
          },
          signal: controller.signal,
        });
        clearTimeout(timeoutId);
        console.log(`[AuthClient.validate] Validate request successful`);
        
        return this.validateResponse(result, CommonDto.withStatus(ValidateResponseSchema));
      } catch (error: any) {
        clearTimeout(timeoutId);
        console.error(`[AuthClient.validate] Validate request error:`, error);
        if (error.name === 'AbortError' || error.message?.includes('aborted') || error.message === 'canceled') {
          throw new Error("Запрос авторизации превысил время ожидания. Проверьте подключение к интернету.");
        }
        throw error;
      }
    } catch (error) {
      console.error(`[AuthClient.validate] Validate request failed:`, error);
      throw error;
    }
  }

  async register(initDataRaw: string, phone_number: string): Promise<RequestResponse<z.infer<typeof RegisterResponseSchema>>> {
    const result = await this.request(
      "POST",
      authEndpoints().register,
      {
        headers: {
          [authEndpoints().header]: initDataRaw,
        },
        jsonPayload: { phone_number },
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(RegisterResponseSchema));
  }

  async verify(initDataRaw: string, phone_number: string, code: string): Promise<RequestResponse<z.infer<typeof TokenSchema>>> {
    const result = await this.request(
      "POST",
      authEndpoints().verify,
      {
        headers: {
          [authEndpoints().header]: initDataRaw,
        },
        jsonPayload: { phone_number, code },
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(TokenSchema));
  }

  async signin(initDataRaw: string): Promise<RequestResponse<z.infer<typeof TokenSchema>>> {
    // Ручка и заголовок зависят от мессенджера: подпись initData считается своим
    // токеном бота, и телеграмным ключом данные из MAX не проверить.
    const { signin, header } = authEndpoints();
    const result = await this.request("POST", signin, {
      headers: {
        [header]: initDataRaw,
      },
    });
    return this.validateResponse(result, CommonDto.withStatus(TokenSchema));
  }
}

export class AuthClient extends AuthClientClass {}
